import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import {InputGridColumnsDatasourceMappingModel} from './input-grid-columns-datasource-mapping.model';

@Component({
  selector: 'dynamic-input-grid-columns-datasource-mapping',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-input-grid-columns-datasource-mapping.component.html'
})
export class DynamicInputGridColumnsDatasourceMappingComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() group: FormGroup;
  @Input() model: InputGridColumnsDatasourceMappingModel;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();
  constructor(protected layoutService: DynamicFormLayoutService, protected validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
